import { render, staticRenderFns } from "./NuevaEtapa.vue?vue&type=template&id=725952f7&"
import script from "./NuevaEtapa.vue?vue&type=script&lang=js&"
export * from "./NuevaEtapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports